var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('change-password-form',{attrs:{"model":_vm.model}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }